import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/headerInternal'
import Footer from '../components/footer'
import Nav from '../components/navInterno'
import './index.css'

export default class Internal extends React.Component {
  render(){
    let data = this.props.data;
    let location = this.props.location.pathname;
    
    var info_helmet = {
      title: 'Liga de Campeones: Todo sobre el torneo más importante del futbol de Europa. ',
      description: 'Conoce a través de varios especiales, todo sobre la Liga de Campeones. Una serie de artículos sobre el torneo más importante del fútbol de Europa como es la Uefa Champions League.',
      keywords: 'liga de campeones, UCL, champions league, champions, futbol, futbol de europa, especiales champions, especiales liga campeones, futbol europeo',
      image: 'https://cdn3.uvnimg.com/94/e6/c897105f45e6b625e571d9e2bf4e/promo-image-uefa.jpg'
    };
    for (let index = 0; index < data.allSitePage.edges.length; index++) {
      const _page = data.allSitePage.edges[index];
      
      if(_page.node.path == location)
      {
        info_helmet.title = _page.node.context.node.title;
        info_helmet.description = _page.node.context.node.description;
        info_helmet.image = _page.node.context.node.article_sharing[0].sharing_image;
        break;
      }
    }
    return (
      <div>
        <Helmet
          title={info_helmet.title}
          meta={[
            { property: 'description', content: info_helmet.description },
            { property: 'keywords', content: 'liga de campeones, UCL, champions league, champions, futbol, futbol de europa, especiales champions, especiales liga campeones, futbol europeo' },
            { property: 'og:title', content: info_helmet.title },
            { property: 'og:description', content: info_helmet.description },
            { property: 'og:image', content: info_helmet.image },
            { property: 'og:url', content: 'https://www.univision.com' + location },
            { property: 'twitter:title', content: info_helmet.title },
            { property: 'twitter:description', content: info_helmet.description },
            { property: 'twitter:image', content: info_helmet.image },
            { property: 'twitter:card', content: 'summary_large_image' },
          ]}
        />
        <Header Pages={data.allSitePage.edges}/>
        <div className="contiene_internal">
          {this.props.children()}
        </div>
        <Nav Pages={data.allSitePage.edges} location={location} />
        <Footer />
      </div>
    )
  }
}

export const query = graphql`
  query SiteTitleQueryInternal {
    allSitePage{
      edges {
        node {
          id
          path
          context 
          {
            slug
            node{
              title
              description
              publishDate
              type
              index
              author_name
              author_image
              image_lead
              label
              article_sharing{
                sharing_image
              }
            }
          }
        }
      }
    }
  }`



// WEBPACK FOOTER //
// ./src/layouts/internal.js